<template>
  <v-sheet
    class="right-toolbar modern-glass-toolbar d-flex flex-column align-center py-1"
    elevation="4"
    rounded="lg"
  >
    <template v-for="(item, index) in tools">
      <v-divider v-if="item.divider" :key="'divider-' + index" class="my-1 full-width" />

      <v-tooltip v-else :key="item.id" left>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            class="my-1 tool-btn"
            :class="{ 'active-tool': item.id === 'pan' ? isPanActive : activeTools.includes(item.id) }"
            :color="item.id === 'pan' ? (isPanActive ? 'primary' : '#64748b') : (activeTools.includes(item.id) ? 'primary' : '#64748b')"
            v-bind="attrs"
            v-on="on"
            @click="emitClick(item.id)"
          >
            <v-icon small>{{ item.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ item.title }}</span>
      </v-tooltip>
    </template>
  </v-sheet>
</template>

<script>
export default {
  name: 'MapShareRightToolbar',
  props: {
    isPanActive: {
      type: Boolean,
      default: true
    },
    activeTools: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tools: [
        { id: 'basemap', title: 'Bản đồ nền', icon: 'mdi-view-grid-outline' },
        { divider: true },
        { id: 'home', title: 'Về vị trí mặc định', icon: 'mdi-home' },
        { id: 'zoom-in', title: 'Phóng to', icon: 'mdi-plus' },
        { id: 'zoom-out', title: 'Thu nhỏ', icon: 'mdi-minus' },
        { id: 'pan', title: 'Bật chế độ di chuyển', icon: 'mdi-hand-back-right' },
        { id: 'refresh', title: 'Làm mới bản đồ', icon: 'mdi-refresh' },
        { divider: true },
        { id: 'fullscreen', title: 'Toàn màn hình', icon: 'mdi-fullscreen' },
      ]
    }
  },
  methods: {
    emitClick(btnName) {
      this.$emit(`click-${btnName}`);
    }
  }
}
</script>

<style scoped>
.right-toolbar {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 40px;
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  z-index: 100;
}
.full-width {
  width: 80%;
}
.tool-btn {
  transition: all 0.2s ease-in-out;
}
.active-tool {
  background-color: rgba(25, 118, 210, 0.15) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.4) !important;
  border-radius: 8px !important;
}
</style>
